import TemplateView from '../../../TemplateView'
import messageResource from '../../../messageResource'
import {WorkflowStatusType} from '../../constants'
import CustomCheckbox from "../../../components/customCheckbox/CustomCheckbox";

export class WorkflowStatusTypeWithCheckboxNode extends TemplateView {
    constructor(type, onChangeCallback) {
        super(null)

        this.type = type;
        this.onChangeCallback = onChangeCallback;

        this.state = {
            checked: false
        }

        this.onStateChanged(() => this._updateView());
    }

    templateHtml() {
        return '<div class="workflowStatusTypeNode"></div>'
    }

    afterRender() {
        this.checkbox = new CustomCheckbox({
            label: this._title(),
            onChange: (config) => this.onChangeCallback(this.type, config.checked),
            checkboxTitleAdditionalClass: "workflowStatusTypeNode_label"
        }).init(this.$el);
    }

    _title() {
        return messageResource.getMessage(this.type === WorkflowStatusType.OPEN ? 'workflow_list.open_tasks' : 'workflow_list.completed_tasks')
    }

    _updateView() {
        this.checkbox.setState({"checked": this.state.checked});
    }
}

export default WorkflowStatusTypeWithCheckboxNode



// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/statusFilter/WorkflowStatusTypeWithCheckboxNode.js